import service from '@/services/restaurant/order'

class OrderObject {
  constructor() {
    this.order = {
      consecutive: null,
      restaurant: '',
      zone: '',
      table: '',
      items: [],
      status: '', // ABIERTA - CERRADA
      state: true
    }
  }
}

const getNewlyAddedItems = (newItems, oldItems) => {
  const oldIds = new Set(oldItems.map(item => item._id))
  return newItems.filter(item => !oldIds.has(item._id))
}

const getNewlyDeletedItems = (newItems, oldItems) => {
  const newIds = new Set(newItems.map(item => item._id))
  return oldItems.filter(item => !newIds.has(item._id))
}

const getNewlyChangedItems = (newItems, oldItems) => {
  // for in
  const changedItems = newItems.reduce((acc, item) => {
    const oldItem = oldItems.find(i => i._id === item._id)
    if (oldItem) {
      if (oldItem.cantidad !== item.cantidad) acc.push(item)
      if (oldItem.detalle !== item.detalle) acc.push(item)
      if (oldItem.check !== item.check) acc.push(item)
    }

    return acc
  }, [])

  return changedItems
}

const getDefaultState = () => ({
  options: {
    printer: '',
    restaurant: '',
    zone: '',
    table: '',
    category: '',
    checkOtrosCargos: true,
    print: true
  },
  filtroFechas: {
    rango: ''
  },
  printing: false,
  order: new OrderObject().order,
  splitOrder: new OrderObject().order,
  orderRow: {},
  status: [
    { value: 'ABIERTA', text: 'info' },
    {
      value: 'EN_PROCESO',
      text: 'warning'
    },
    {
      value: 'ENTREGADA',
      text: 'warning'
    },
    {
      value: 'CERRADA', // PAGADA
      text: 'success'
    },
    {
      value: 'CANCELADA',
      text: 'danger'
    },
    {
      value: 'VIATICOS',
      text: 'warning'
    },
    {
      value: 'REGALIAS',
      text: 'warning'
    },
    {
      value: 'EMPLEADOS',
      text: 'warning'
    }
  ],

  list: [],
  onlineList: [],
  pageInfo: {},
  totalRegistros: 0,
  totalsByfilter: null,
  isListening: false,
  currentRow: null,
  saved: 'null',
  currentSlide: 0,
  viewGrid: true,
  printOrder: true,
  selectedCategorias: [],
  deletedList: [],
  pageInfoDeleted: {},
  deletedOrderList: []
})

export const state = () => getDefaultState()

export const mutations = {
  SET_TOTALS_BY_FILTER: (state, val) => (state.totalsByfilter = val),
  SET_PRINTING: (state, val) => (state.printing = val),
  SET_VIEW_GRID: (state, value) => {
    state.viewGrid = value
  },
  SET_PRINT_ORDER: (state, value) => {
    state.printOrder = value
  },
  SET_SLIDE: (state, index) => (state.currentSlide = index),
  RESET_STATE: state => Object.assign(state, getDefaultState()),
  RESET: state => (state.order = new OrderObject().order),
  RESET_SPLIT: state => (state.splitOrder = new OrderObject().order),

  SET_OTROS_CARGOS: (state, value) => {
    if (value === undefined) {
      const option = localStorage.getItem('checkOtrosCargos')

      state.options.checkOtrosCargos = option === 'true'
    } else {
      localStorage.setItem('checkOtrosCargos', value)
      state.options.checkOtrosCargos = value
    }
  },
  SET_PRINT: (state, value) => {
    if (value === undefined) {
      const option = localStorage.getItem('print')
      state.options.print = option === 'true'
    } else {
      localStorage.setItem('print', value)
      state.options.print = value
    }
  },
  SET_OPTIONS: (state, obj) => {
    state.options.restaurant = obj.restaurant
    state.options.zone = obj.zone
    state.options.table = obj.table
    state.options.category = obj.category
  },
  SET_ROW: (state, row) => (state.currentRow = row),
  SET_ORDER: (state, obj) => (state.order = obj),
  SET_ORDER_ROW: (state, obj) => {
    state.orderRow = obj
  },
  SET_LIST: (state, obj) => {
    state.list = [...new Set([...state.list.map(JSON.stringify), ...obj.feed.map(JSON.stringify)])].map(JSON.parse)
    state.pageInfo = obj.pageInfo
  },
  UPDATE_LIST: (state, obj) => {
    const nObj = state.list.find(e => e._id === obj._id)
    if (!nObj) state.list = [obj, ...state.list]
    else Object.keys(nObj).forEach(i => (nObj[i] = obj[i]))
    state.saved = true
  },
  UPDATE_LIST_STATUS: (state, obj) => {
    const nObj = state.list.find(e => e._id === obj._id)

    if (nObj) nObj.status = obj.status
  },
  DELETE_ORDER_ONLINE_LIST: (state, obj) => {
    const order = state.onlineList.find(e => e._id === obj._id)
    if (order) {
      order.items = order.items.filter(item => !obj.items.some(i => i._id === item._id))
    }
  },
  UPDATE_ONLINE_LIST: (state, obj) => {
    // TODO: este filtro de catagorias deberia estar en Backend Y FILTRAR EN EL PUBSUB SEGUN LAS CATEGORIAS SELECCIONADAS.
    // filtra los items que no son de la categoria filtrada
    const selectedCategorias = state.selectedCategorias
    const activeFilters = selectedCategorias.filter(cat => cat.check)
    const filteredItems = obj.items.filter(item => activeFilters.some(filter => item._idCategoria.some(catId => catId === filter._id)))
    obj.items = filteredItems

    const nObj = state.onlineList.find(e => e._id === obj._id)

    // check if item is new
    const newItems = obj.items
    const oldItems = nObj?.items || []
    const newlyAdded = getNewlyAddedItems(newItems, oldItems)
    const someDeleted = getNewlyDeletedItems(newItems, oldItems)
    const someChanged = getNewlyChangedItems(newItems, oldItems)

    if (!nObj && newlyAdded.length > 0 && someDeleted.length === 0) state.onlineList = [...state.onlineList, obj]
    else {
      if (newlyAdded.length === 0 && someDeleted.length === 0 && someChanged.length === 0) {
        console.log('No hay items nuevos en la orden ❌')
        delete obj.items
      } else {
        if (newlyAdded.length > 0) console.log('Si hay items nuevos en la orden ✅')
        if (someDeleted.length > 0) {
          console.log('Si hay items eliminados en la orden ✅')
          someDeleted.forEach(item => {
            console.log('Hay item eliminado', item)
            const orderItem = nObj.items.find(i => i._id === item._id)
            if (orderItem) {
              orderItem.cancelled = true
            }
          })
        }
        if (someChanged.length > 0) {
          console.log('Si hay items cambiados en la orden ✅')
          someChanged.forEach(item => {
            console.log('Hay item cambiado', item)
            const orderItem = nObj.items.find(i => i._id === item._id)
            orderItem.check = item.check
            orderItem.cantidad = item.cantidad
            orderItem.detalle = item.detalle
          })
        }

        nObj.items = [...nObj.items, ...newlyAdded]
      }

      // actualiza otros campos si cambiaron. no se usa, ahora se utiliza la hora del item
      // actualiza solo si el item es diferente
      // delete obj.createdAt
      // delete obj.updatedAt
      // delete obj.table
      // delete obj.zone
      // Object.keys(nObj).forEach(i => {
      //   if (  nObj[i] !== obj[i] && obj[i] !== undefined) {
      //     nObj[i] = obj[i]
      //   }
      // })
    }
  },
  SET_FULL_ONLINE_LIST: (state, objs) => {
    const selectedCategorias = state.selectedCategorias
    const activeFilters = selectedCategorias.filter(cat => cat.check)
    const filteredItems = objs.reduce((acc, obj) => {
      const filtered = obj.items.filter(item => activeFilters.some(filter => item._idCategoria.some(catId => catId === filter._id)))
      acc.push({ ...obj, items: filtered })
      return acc
    }, [])
    state.onlineList = filteredItems
  },
  SET_ONLINE_LIST: (state, objs) => {
    // Preserve existing cancelled items across list refreshes
    const existingCancelledByOrder = (state.onlineList || []).reduce((acc, order) => {
      const cancelledItems = (order.items || []).filter(i => i.cancelled)
      if (cancelledItems.length) acc[order._id] = cancelledItems
      return acc
    }, {})

    // filtra los items que no son de la categoria filtrada
    const selectedCategorias = state.selectedCategorias
    const activeFilters = selectedCategorias.filter(cat => cat.check)
    const filteredItems = objs.reduce((acc, obj) => {
      const filtered = obj.items.filter(item => activeFilters.some(filter => item._idCategoria.some(catId => catId === filter._id)))
      const cancelledForOrder = existingCancelledByOrder[obj._id] || []
      const mergedItems = [...filtered]
      cancelledForOrder.forEach(cancItem => {
        if (!mergedItems.some(i => i._id === cancItem._id)) {
          mergedItems.push(cancItem)
        }
      })
      acc.push({ ...obj, items: mergedItems })
      return acc
    }, [])

    state.onlineList = filteredItems
  },
  UPDATE_ONLINE_LIST_STATUS: (state, obj) => {
    const nObj = state.onlineList.find(e => e._id === obj._id)

    if (nObj) nObj.status = obj.status
  },
  SET_SELECTED_CATEGORIAS: (state, obj) => {
    state.selectedCategorias = obj
  },
  SET_DELETED_LIST: (state, obj) => {
    state.deletedList = [...new Set([...state.deletedList.map(JSON.stringify), ...obj.feed.map(JSON.stringify)])].map(JSON.parse)
    state.pageInfoDeleted = obj.pageInfo
  },
  RESET_DELETED_LIST: state => {
    state.deletedList = []
    state.pageInfoDeleted = {}
  },
  SET_DELETED_ORDER_LIST: (state, obj) => {
    state.deletedOrderList = obj
  }
  // DELETE_LIST: (state, { obj }) => {
  //   state.list = state.list.filter(e => e._id !== obj._id)
  // },
  // SAVE_CHANGES: (state, obj) => {
  //   state.restaurant = obj
  //   state.saved = false
  // }
}

export const actions = {
  addSplit: ({ state }, order) => {
    // agrega al split
    const currSplitOrder = state.splitOrder.items.find(i => i._id === order._id)

    if (currSplitOrder) currSplitOrder.cantidad += 1
    else state.splitOrder.items.push({ ...order, cantidad: 1 })

    // elimina de la orden
    const currOrder = state.order.items.find(i => i._id === order._id)

    if (currOrder.cantidad > 1) currOrder.cantidad -= 1
    else state.order.items = state.order.items.filter(i => i._id !== order._id)
  },
  substractSplit: ({ state }, order) => {
    // agrega a la orden
    const currSplitOrder = state.splitOrder.items.find(i => i._id === order._id)

    if (currSplitOrder.cantidad > 1) currSplitOrder.cantidad -= 1
    else state.splitOrder.items = state.splitOrder.items.filter(i => i._id !== order._id)

    // elimina del split
    const currOrder = state.order.items.find(i => i._id === order._id)

    if (currOrder) currOrder.cantidad += 1
    else state.order.items.push({ ...order, cantidad: 1 })
  },
  getOrders({ commit, rootGetters, state }) {
    if (!state.isListening) {
      state.isListening = true

      return service.subscriptionNewOrder(
        rootGetters['facturacion/emisorStore/get_Id'],

        result => {
          return commit('UPDATE_ONLINE_LIST', result)
        }
      )
    }
  },
  resetList: ({ state }) => {
    state.list = []
    state.pageInfo = {}
  },
  resetOrder: ({ commit }) => {
    commit('RESET')
    commit('SET_SLIDE', 0)
  },
  resetSplitOrder: ({ commit, state }) => {
    commit('RESET_SPLIT')
    // state.splitOrder.items = []
  },
  create: async ({ commit, dispatch, rootGetters, state }) => {
    const { userSession, ...currentOrder } = state.order

    if (state.order.restaurant) currentOrder.restaurant = state.order.restaurant?._id || state.order.restaurant
    if (state.order.zone) currentOrder.zone = state.order.zone?._id || state.order.zone
    if (state.order.table) currentOrder.table = state.order.table?._id || state.order.table

    let lastIndex = 0

    if (!state.order._id || state.order.items.length === 0) lastIndex = 1
    else {
      const lastDefindedItem = state.order.items.findLast(i => i.index !== undefined)

      lastIndex = lastDefindedItem?.index + 1 || 1
    }

    // elimina propiedades no utilizadas al guardar.
    currentOrder.items = currentOrder.items.map(i => {
      const { cuentaContablePorCobrar, ...rest } = i
      return {
        ...rest,
        ...(cuentaContablePorCobrar && { cuentaContablePorCobrar: { _id: cuentaContablePorCobrar?._id } }),
        index: i.index ?? lastIndex
      }
    })

    return service
      .create({
        ...currentOrder,
        emisor: {
          _id: await rootGetters['facturacion/emisorStore/get_Id']
        }
      })
      .then(result => {
        // if (state.list.length)
        commit('UPDATE_LIST', {
          ...currentOrder,
          consecutive: result.consecutive,
          _id: result._id
        })
        state.order.consecutive = result.consecutive
        state.order._id = result._id

        // dispatch(
        //   'webpush',
        //   {
        //     title: 'JIT: Nueva Orden',
        //     body: `Orden #${result.consecutive}`,
        //     url: 'https://jit.cr/restaurante/cocina'
        //   },
        //   { root: true }
        // )

        return result
      })
  },
  readTotal: async ({ state, rootGetters }) =>
    service.readTotal(await rootGetters['facturacion/emisorStore/get_Id']).then(response => {
      state.totalRegistros = response
    }),
  readTotalByFilter: async ({ commit, rootGetters }, filter) =>
    service.readTotalByFilter(await rootGetters['facturacion/emisorStore/get_Id'], filter).then(response => {
      commit('SET_TOTALS_BY_FILTER', response)
    }),
  readByTable: async ({ commit, state, dispatch, rootGetters }, input) => {
    return service.readByTable(rootGetters['facturacion/emisorStore/get_Id'], input.zone, input.table, input.status).then(result => {
      if (result) {
        state.order = result
      } else dispatch('resetOrder')

      return true
    })
  },
  setStatus: async ({ state, dispatch, commit }, { _id, status, razon }) => {
    return service.setStatus(_id, status, razon).then(result => {
      if (state.list.length)
        commit('UPDATE_LIST_STATUS', {
          _id,
          status
        })

      // TODO: notifica solo a meseros, no debe notificar a todos los que están suscritos. Para esto se necesita un modulo de notificaciones por TOPIC
      // if (status === 'ENTREGADA')
      // dispatch(
      //   'webpush',
      //   {
      //     title: 'JIT: Orden Lista',
      //     body: `Orden #${consecutive}`,
      //     url: 'https://jit.cr/restaurante/cocina'
      //   },
      //   { root: true }
      // )

      return result
    })
  },
  checkItem: async ({}, { _idOrder, _id, check }) => {
    return service.checkItem(_idOrder, _id, check).then(result => {
      return result
    })
  },
  checkOrderItems: async ({}, { _idOrder, _idItems, express }) => {
    return service.checkOrderItems(_idOrder, _idItems, express).then(result => {
      return result
    })
  },

  readBySearchString: async ({ state, rootGetters }, { searchString }) =>
    service.readBySearchString(rootGetters['facturacion/emisorStore/get_Id'], searchString),

  readOrdersByStatus: async ({ commit, rootGetters }, { status, restaurant, categorias, limit, fullList = false }) =>
    service.readOrdersByStatus(rootGetters['facturacion/emisorStore/get_Id'], restaurant, status, categorias, limit).then(response => {
      if (fullList) commit('SET_FULL_ONLINE_LIST', response)
      else commit('SET_ONLINE_LIST', response)
      return response
    }),

  readAllByEmisor: async ({ commit, state, dispatch, rootGetters }, { restart = false, limit = 10, filter = null }) => {
    if (restart) await dispatch('resetList')

    // manufactura, reventa, consumible: tipoProducto === '02' - '03' - '04'
    return service.readAllByEmisor(rootGetters['facturacion/emisorStore/get_Id'], state.pageInfo.nextPageCursor, limit, filter).then(response => {
      return commit('SET_LIST', response)
    })
  },

  readItemDeleted: async ({ commit, state, dispatch, rootGetters }, { restart = false, limit = 10, filter = null }) => {
    if (restart) {
      commit('RESET_DELETED_LIST')
    }

    return service.readItemDeleted(rootGetters['facturacion/emisorStore/get_Id'], state.pageInfoDeleted.nextPageCursor, limit, filter).then(response => {
      return commit('SET_DELETED_LIST', response)
    })
  },

  readItemDeletedByOrder: async ({ commit }, { _id }) =>
    service.readItemDeletedByOrder(_id).then(response => {
      return commit('SET_DELETED_ORDER_LIST', response)
    }),

  readById: async ({ commit }, { _id }) =>
    service.readById(_id).then(response => {
      commit('SET_ORDER_ROW', response)
      return response
    }),

  setMermaDate: async ({}, _idOrder) => {
    return service.setMermaDate(_idOrder)
  }
  // delete: ({ commit }, { items }) =>
  //   service.delete(items).then(result => {
  //     result.forEach(i => {
  //       if (i.state) commit('DELETE_LIST', { obj: i })
  //     })
  //     return result
  //   }),
  // saveChanges: ({ commit }, input) => commit('SAVE_CHANGES', input)
}

export const getters = {
  orderStatus: state => value => {
    const status = state.status.find(e => e.value === value)

    return status?.text || 'info'
  }
}
